<template>
  <div class="border rounded-t w-[80%]">
    <div class="bg-[#FFECE9] py-[8px] px-[28px] rounded-t text-black font-[500]">
      Varian Produk
    </div>
    <b-table
      :items="items"
      :fields="fieldsVariantBundling"
    >
      <template #cell(no)="row">
        {{ row.index + 1 }}
      </template>
      <template #cell(bundle_component)="row">
        <BundleComponentProduct
          v-for="(item, index) in row.item.bundle_component || row.item.components"
          :key="`${item.product_id}-${index}-${row.item.variant_id}`"
          :item="item"
        />
      </template>
    </b-table>
  </div>
</template>

<script>
/**
 * Component untuk menampilkan detail varian produk dalam bundle varian
 * @param {Array} items - Array item varian produk
 */
import { fieldsVariantBundling } from '../config'
import BundleComponentProduct from './BundleComponentProduct.vue'

export default {
  components: {
    BundleComponentProduct,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fieldsVariantBundling,
    }
  },
}
</script>
